import { defineMessages } from 'react-intl';

export default defineMessages({
	virtualServiceAgent: {
		defaultMessage: 'Virtual service agent',
		description: 'Text message for virtual service agent header button',
		id: 'virtual-service-agent-header.virtual-service-agent.title',
	},
	chat: {
		defaultMessage: 'Chat',
		description: 'Text message for chat header button',
		id: 'virtual-service-agent-header.chat.title',
	},
});
